import React, { useContext } from "react";

interface FocusContext {
  toggle: (focused: boolean) => void;
  current: boolean;
}

export const FocusModeContext = React.createContext<FocusContext>({
  toggle: (focused: boolean) => {},
  current: false,
});

export const isFocused = () => useContext(FocusModeContext).current;

export const useUpdateFocus = () => useContext(FocusModeContext).toggle;
